import { render, staticRenderFns } from "./hot-dialog.vue?vue&type=template&id=9016e6f2&scoped=true&"
import script from "./hot-dialog.vue?vue&type=script&lang=js&"
export * from "./hot-dialog.vue?vue&type=script&lang=js&"
import style0 from "./hot-dialog.vue?vue&type=style&index=0&id=9016e6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9016e6f2",
  null
  
)

export default component.exports